import { useEffect, useState } from 'react';

/**
 * Adia a propagação de um valor até ele parar de mudar por `delay` ms.
 *
 * Usado nos filtros das listagens: sem isso cada tecla digitada disparava uma
 * requisição (7 requisições para "Mariana" numa base de 22 mil alunos), com o
 * agravante de as respostas poderem chegar fora de ordem e a lista exibir o
 * resultado de uma busca antiga.
 *
 * @template T
 * @param {T} valor valor que muda a cada tecla
 * @param {number} delay milissegundos de silêncio antes de propagar
 * @returns {T} valor estabilizado
 */
export function useDebounce(valor, delay = 400) {
  const [valorComAtraso, setValorComAtraso] = useState(valor);

  useEffect(() => {
    const id = setTimeout(() => setValorComAtraso(valor), delay);
    return () => clearTimeout(id);
  }, [valor, delay]);

  return valorComAtraso;
}

export default useDebounce;
